import OpenAccountForm from './OpenAccountForm'
import Onboarding from './Onboarding'

/*
  Quem busca a conta é a página, que precisa dela para decidir quais abas existem. Aqui
  resta escolher o que mostrar: o acompanhamento da conta aberta, ou o formulário que a
  abre.
*/
export default function AccountData ({
  account = null,
  readiness = null,
  requestConfig,
  onAccountOpened: handleAccountOpened = () => {},
  onAccountUpdated: handleAccountUpdated = () => {}
}) {
  if (account) return (
    <Onboarding
      account={account}
      requestConfig={requestConfig}
      onAccountUpdated={handleAccountUpdated}
    />
  )

  return (
    <OpenAccountForm
      readiness={readiness}
      requestConfig={requestConfig}
      onAccountOpened={handleAccountOpened}
    />
  )
}
